import { makeResetStyles, shorthands, tokens } from '@fluentui/react-components';
import { positionFill } from './../shared-cell-style';

/* eslint-disable no-unused-vars */
export const iconStyles = {
  root: {
    position: 'relative',
    top: '3px',
    marginLeft: '12px',
    marginRight: '5px',
  },
};

export const videoSvgIconStyles = {
  ...iconStyles,
  root: {
    ...iconStyles.root,
    top: '5px',
    width: '15px',
    opacity: 0.8,
  },
};

export const useFolderGridCellStyle = makeResetStyles({
  display: 'flex',
  flexWrap: 'nowrap',
  boxSizing: 'border-box',
  height: '86px',

  '& .folder-grid-cell-content': {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    flexShrink: 1,

    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: '#fff',
    ...shorthands.padding('16px'),
    cursor: 'pointer',

    ...shorthands.borderRadius('6px'),
    ...positionFill,

    '& .folder-thumbnail': {
      display: 'flex',
      flexGrow: 0,
      flexShrink: 0,
      marginRight: '16px',
    },

    '& .folder-info': {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      flexShrink: 1,
      justifyContent: 'space-between',
      height: '100%',
      paddingTop: '6px',

      ...shorthands.overflow('hidden'),
      whiteSpace: 'nowrap',

      '& .folder-name': {
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '16px',

        '& .highlighted-text': {
          backgroundColor: tokens.colorPaletteYellowBackground3,
        },
      },

      '& .folder-newlabel-counting': {
        display: 'flex',
        flexDirection: 'row',
        ...shorthands.padding('1px'),

        '& .counting-info': {
          display: 'block',
          ...shorthands.overflow('hidden'),
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',

          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '15px',
          textAlign: 'right',

          position: 'relative',
          top: '2px',

          '& .count-icon': {
            marginLeft: '12px',
            marginRight: '4px',
            fontSize: '14px',
            '&:first-child': {
              marginLeft: '0px',
            },
          },

          '& span': {
            verticalAlign: 'top',
          },
        },

        '& .empty-desc': {
          fontSize: '12px',
        },
      },
    },
  },

  '& .grid-cell-with-accessory': {
    paddingRight: '54px',
  },

  '& .folder-cell-accessory': {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    width: '42px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '& .folder-grid-loading-cell-content': {
    height: '100%',
  },

  '& .selectable-cell-card': {
    backgroundColor: 'white',
  },
});
